<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class="  mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Rental </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/rental/gin/index"> Manage Rental GIN  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Create Rental GIN  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
<div class="container-fluid">
  <div class="card bdr-rad2 mt-1 shadow p-2 ">
  <div  class="card-body custom_bdr_rds">


  


  

   

                    <form @submit.prevent="SaveQuotation()" >

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">Issue Date *</label>
      <input type="date" v-model="all_data.date" style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">Customer </label>
      <v-select class="font-size_def" label="label" v-model="all_data.user_full_name" :options="mcustomers" @input="setCustomer"></v-select>
      <input v-model="all_data.user_full_name_id" type="hidden" />
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">Type</label>
      <input v-model="all_data.type" class="form-control" style="font-size: small;" disabled>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
      <label class="custom-label" style="font-size: small;">Sales Person </label>
      <v-select class="font-size_def" label="label" v-model="all_data.advisor_id" :options="advisors"></v-select>
    </div>
  </div>
</div>

<div class="row">
    <div class="col-md-3">
    <div class="form-group">
      <label class="custom-label" style="font-size: small;">Contact No.</label>
      <input v-model="all_data.user_contact_tel1" style="font-size: small;" class="form-control" required>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
      <label class="custom-label" style="font-size: small;">Remarks</label>
      <textarea v-model="all_data.remarks" class="form-control" rows="2"></textarea>
    </div>
  </div>

</div>


<!-- <div class="row">
  <div class="col-md-3">
    <button type="button"  @click="pendingQuotation()"  class="btn btn-sm  btn-outline-primary mb-1 font-size_def"> View Pending Quotation</button>

    </div>
</div> -->














<div class="card custom_bdr_rds">
        <div class="card-body custom_bdr_rds">
    <h6 class="purchitem mb-2"><b>Add Parts</b></h6>
    <div class="table-responsive mb-1">
      <table style="font-size: small; " class="table  table-sm table-hover ">
        <thead class="background_color2">
          <tr>
            <th></th>
            <th style="width: 15%;"><div class="form-group custom-form required"><label class="custom-label2">Model Name</label></div></th>
            <th style="width: 15%;"><div class="form-group custom-form required"><label class="custom-label2">Engi Number</label></div></th>
            <th style="width: 15%;"><div class="form-group custom-form required"><label class="custom-label2">Chassis Number</label></div></th>
            <th><div class="form-group custom-form required"><label class="custom-label2">Color</label></div></th>
            <th><div class="form-group custom-form required"><label class="custom-label2">From Date</label></div></th>
            <th><div class="form-group custom-form required"><label class="custom-label2">To Date</label></div></th>
            <th><div class="form-group custom-form required"><label class="custom-label2">GIN Qty</label></div></th>
            <th><div class="form-group custom-form required"><label class="custom-label2">Per Day Rate</label></div></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td ><v-select v-model="detail[0].vehicle" label="modelname" :options="vehicles" @input="setVehicle(0)"></v-select></td>
            <td><v-select v-model="detail[0].engi_no" label="engineno" :options="engineOptions" @input="setVehicleByEngine(0)"></v-select></td>
            <td><v-select v-model="detail[0].chassis_no" label="chassisno" :options="chassisOptions" @input="setVehicleByChassis(0)"></v-select></td>
            <td><input v-model="detail[0].color" style="font-size: small;" class="form-control" readonly /></td>
            <td><input type="date" v-model="detail[0].from_date" style="font-size: small;" class="form-control" /></td>
            <td><input type="date" v-model="detail[0].to_date" style="font-size: small;" class="form-control" /></td>
            <td><input v-model="detail[0].qty" style="font-size: small;" class="form-control text_right" value="1" readonly></td>
            <td><input v-model="detail[0].price" style="font-size: small;" class="form-control text_right" /></td>
            <td class="custom-icon"></td>
            <!-- <b-icon @click="add" class="ms-2 mt-2" width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon> -->
          </tr>
          <tr v-for="key in count" :key="key">
            <td><b-icon @click="remove" class="ms-2 mt-2" width="8" type="button" icon="dash-lg" scale="2" variant=""></b-icon></td>
            <td><v-select v-model="detail[key].vehicle" label="modelname" :options="vehicles" @input="setVehicle(key)"></v-select></td>
            <td><v-select v-model="detail[key].engi_no" label="engineno" :options="engineOptions" @input="setVehicleByEngine(key)"></v-select></td>
            <td><v-select v-model="detail[key].chassis_no" label="chassisno" :options="chassisOptions" @input="setVehicleByChassis(key)"></v-select></td>
            <td><input v-model="detail[key].color" style="font-size: small;" class="form-control" readonly /></td>
            <td><input type="date" v-model="detail[key].from_date" style="font-size: small;" class="form-control" /></td>
            <td><input type="date" v-model="detail[key].to_date" style="font-size: small;" class="form-control" /></td>
            <td><input v-model="detail[key].qty" style="font-size: small;" class="form-control text_right" value="1" readonly></td>
            <td><input v-model="detail[key].price" style="font-size: small;" class="form-control text_right" /></td>
            <td class="custom-icon"><b-icon @click="add" class="ms-3 mt-2" width="8" type="button" icon="plus-lg" scale="2" variant=""></b-icon></td>
          </tr>
         
         
          
        </tbody>


        </table>
       
    </div>
    </div>
    </div>
    

    <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
<div class="d-flex  ">
        <button v-if="!all_data.saved_id" type="submit" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad">Create</button>
        <button v-else type="button" @click="confirmRental()" class="mr-1 btn btn-outline-primary mb-1 font-size_def bdr-rad">Confirm</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
                <br><br>
              </div> 
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    
    </template>
    <script src="/js/vue-select/vue-select.js"> </script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/vue/1.0.13/vue.min.js"></script>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {
        name: 'RentalGIn',

        mounted(){
   
    this.loadCustomer();
    this.all_data.type = 'Rental GIN';
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'id':this.$route.query.id,
            count: 0,
        total:0,
        selectedOption: null, // Store the selected option
        subtotal:"0.00",
        gpmrg_total:"0.00",
        gpMrgPre_total:"0.00",
        final_total:"0.00",
        qty:0,
        mcustomers:[],
        vehicles:[],
        engineOptions:[],
        chassisOptions:[],
        mproducts:[],
        contacts:[],
      salespeoples:[

      ],
      errors: {},
     
      
      all_data:{},
        customer:{},
        mcustomers:[],
        quotation:{
          'validity_period':{
            label: 'Select Validity Period', value: ''
          },
          'payment_method':{
            label: 'Cash', value: 'Cash'
          },
          'remarks':'',
          'special_discount':0.00,
        },
        sales:{},
        technicians:[],
        advisors:[],
        detail:[
      {qty:1},  
      ],
      infoModal1: {
          id: 'info-modal1',
          title: '',
          content: [],
        },
      infoModal2: {
          id: 'info-modal2',
          title: '',
          content: [],
        },

      paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: '30 Days Credit', value: '30 Days Credit' },
            { label: '45 Days Credit', value: '45 Days Credit' },
            { label: '60 Days Credit', value: '60 Days Credit' },
            { label: 'Consignment', value: 'Consignment' },
            // Add more options as needed
        ],
        validity_periodop: [
            { label: 'Select Validity Period', value: '' },
            { label: '7 Days', value: '7 Days' },
            { label: '14 Days', value: '14 Days' },
          
           
        ],
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },
    

        methods : {

       




     

    

    
     async loadCustomer() {
       
     
       try {
         const { data} = await  axios.get('/mcustomer/customerload',{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.mcustomers = data.customers || [];
          const vehicleData = await axios.get('/ivehicleinventory/index',{
            params: {
              page: 1,
              perPage: 1000,
            },
            headers:{
              'Authorization':'Bearer '+this.access_token,
              'Content-type': 'application/json',
            }
          });
          this.vehicles = vehicleData.data.all_data || [];
          this.engineOptions = this.vehicles;
          this.chassisOptions = this.vehicles;
          this.all_data.type = 'Rental GIN';
          this.advisors = data.users || [];
          this.all_data.date = this.all_data.date || new Date().toISOString().slice(0, 10);
          if (this.id) {
            await this.loadRentalGin();
          }
       
         
      } catch (error) {
         console.log(error.response);
       }
     },

     async loadRentalGin() {
       try {
         const { data } = await axios.get('/rentalgin/view?id=' + this.id, {
           headers: {
             'Authorization': 'Bearer ' + this.access_token,
             'Content-type': 'application/json',
           }
         });
         if (data.status === 1) {
           this.all_data = {
             ...this.all_data,
             ...data.all_data,
             saved_id: data.all_data.id,
           };
           this.detail = (data.detail || []).map((row) => ({
             ...row,
             vehicle: this.vehicles.find((v) => v.id == row.vehicle_id) || null,
           }));
           this.count = Math.max(0, this.detail.length - 1);
         }
       } catch (error) {
         console.log(error.response || error);
       }
     },

     setCustomer(customer) {
       this.all_data.user_full_name_id = customer ? customer.value : '';
     },

     setVehicle(id) {
       const selected = this.detail[id].vehicle;
       if (!selected) {
         return;
       }

       this.$set(this.detail[id], 'engi_no', selected.engineno || '');
       this.$set(this.detail[id], 'chassis_no', selected.chassisno || '');
       this.$set(this.detail[id], 'color', selected.colorcode || '');
       this.$set(this.detail[id], 'vehicle_model_id', selected.id || '');
       this.$set(this.detail[id], 'model', selected.modelname || '');
     },

     setVehicleByEngine(id) {
       const engineValue = this.detail[id].engi_no && this.detail[id].engi_no.engineno ? this.detail[id].engi_no.engineno : this.detail[id].engi_no;
       const selected = this.engineOptions.find((item) => item.engineno === engineValue);
       if (selected) {
         this.$set(this.detail[id], 'vehicle', selected);
         this.$set(this.detail[id], 'engi_no', selected.engineno || '');
         this.$set(this.detail[id], 'chassis_no', selected.chassisno || '');
         this.$set(this.detail[id], 'color', selected.colorcode || '');
         this.$set(this.detail[id], 'vehicle_model_id', selected.id || '');
         this.$set(this.detail[id], 'model', selected.modelname || '');
       }
     },

     setVehicleByChassis(id) {
       const chassisValue = this.detail[id].chassis_no && this.detail[id].chassis_no.chassisno ? this.detail[id].chassis_no.chassisno : this.detail[id].chassis_no;
       const selected = this.chassisOptions.find((item) => item.chassisno === chassisValue);
       if (selected) {
         this.$set(this.detail[id], 'vehicle', selected);
         this.$set(this.detail[id], 'engi_no', selected.engineno || '');
         this.$set(this.detail[id], 'chassis_no', selected.chassisno || '');
         this.$set(this.detail[id], 'color', selected.colorcode || '');
         this.$set(this.detail[id], 'vehicle_model_id', selected.id || '');
         this.$set(this.detail[id], 'model', selected.modelname || '');
       }
     },

     

     

     async loadPrice(id) {
       
     
       try {
         const { data} = await  axios.post('/servicejob/loadprice',{idproduct:this.detail[id].idproduct},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          this.$set(this.detail[id], 'price', data.selling_price);
          this.$set(this.detail[id], 'avlqty', data.avl);
          this.$set(this.detail[id], 'ave_cost', data.ave_cost);
          this.$set(this.detail[id], 'status', data.status);
          // this.sales = data.salespeoples;
          
         
       } catch (error) {
         console.log(error.response);
       }
     },

     async calculateqty(id) {
      
     if(!this.detail[id].line_discount){
      this.detail[id].line_discount = 0;
     } 
    
     if(parseFloat(this.detail[id].avlqty) < parseFloat(this.detail[id].qty)){
      alert("You are not allowed enter more than remaining qty")
      this.$set(this.detail[id], 'qty', this.detail[id].avlqty);

      
     }
  const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100).toFixed(2);
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total1 = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total1 = gpMrg_total1 + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

  }

  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total1.toFixed(2);

  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);
  
     },

     async calculatediscount(id) {
     if(!this.detail[id].qty){
      this.detail[id].qty = 0;
     } 
  const line_amount = this.detail[id].price * this.detail[id].qty * (100 - this.detail[id].line_discount) / 100;
  this.$set(this.detail[id], 'line_amount', line_amount);

  const gpMrg = (line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
  this.$set(this.detail[id], 'gp_margin', gpMrg);

  const gpMrgPre = (gpMrg/line_amount*100).toFixed(2);
  this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);

  let line_amount_tot = 0;
  let gpMrg_total = 0;
  let gpMrgPre_total = 0;
  for (let i = 0; i <= this.count; i++) {
 line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

 gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

 
 
  }
  this.subtotal = line_amount_tot.toFixed(2);
  this.gpmrg_total = gpMrg_total.toFixed(2);
  this.gpMrgPre_total = (gpMrg_total1 / line_amount_tot * 100).toFixed(2);

  const total = line_amount_tot - this.quotation.special_discount;
  this.final_total = total.toFixed(2);

     },


     async calculatelinamt(id) {

      const discount = (100 - ((this.detail[id].line_amount*100)/(this.detail[id].price*this.detail[id].qty))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', discount);

      const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      const gpMrgPre = (gpMrg/this.detail[id].line_amount*100).toFixed(2);
      this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },

     async calculategpmarg(id) {
      
       const dis = (100-((parseFloat(this.detail[id].gp_margin / this.detail[id].qty) + parseFloat(this.detail[id].ave_cost))*100/this.detail[id].price)).toFixed(2);
        this.$set(this.detail[id], 'line_discount', dis);


        const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrgPre = (this.detail[id].gp_margin/line_amount*100).toFixed(2);
        this.$set(this.detail[id], 'gp_margin_precentage', gpMrgPre);


      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);


     },

     async calculategppre(id) {

      const dis =  (100 -(this.detail[id].ave_cost*10000/((this.detail[id].price)*(100-this.detail[id].gp_margin_precentage)))).toFixed(2);
      this.$set(this.detail[id], 'line_discount', dis);

      const line_amount = (this.detail[id].price * this.detail[id].qty * (100 - dis) / 100).toFixed(2);
        this.$set(this.detail[id], 'line_amount', line_amount);

        const gpMrg = (this.detail[id].line_amount - this.detail[id].ave_cost*this.detail[id].qty).toFixed(2);
      this.$set(this.detail[id], 'gp_margin', gpMrg);

      let line_amount_tot = 0;
      let gpMrg_total = 0;
      let gpMrgPre_total = 0;
      for (let i = 0; i <= this.count; i++) {
      line_amount_tot = line_amount_tot + this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100;

      gpMrg_total = gpMrg_total + (( this.detail[i].price * this.detail[i].qty * (100 - this.detail[i].line_discount) / 100) - this.detail[i].ave_cost*this.detail[i].qty);

    
    
      }
      this.subtotal = line_amount_tot.toFixed(2);
      this.gpmrg_total = gpMrg_total.toFixed(2);
      this.gpMrgPre_total = (gpMrg_total / line_amount_tot * 100).toFixed(2);


      const total = line_amount_tot - this.quotation.special_discount;
      this.final_total = total.toFixed(2);



     },



     async spe_dis() {
        const total = this.subtotal - this.quotation.special_discount;
        this.final_total = total.toFixed(2);
     },

     validate(){
      this.errors = {};
      if(this.squatation.idcustomer == null){
        this.$set(this.errors, 'idCustomerError', "Customer field is required");
      }
      if(this.squatation.customer_contact == null){
        this.$set(this.errors, 'customerContactError', "Customer Contact field is required");
      }
      if(this.sales == null){
        this.$set(this.errors, 'salespeoplesError', "Sales Person field is required");
      }
      if(this.quotation.id_brand == null){
        this.$set(this.errors, 'idbrandError', "Brand field is required");
      }
     },

    async SaveQuotation() {
     
   

   
        try {
         const { data} = await  axios.post('/rentalgin/create',{userid:this.userid,all_data:this.all_data,detail:this.detail,count:this.count},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/rental/gin/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
    
       
      
 
      
     },

    async confirmRental() {
      try {
        const { data } = await axios.post('/rentalgin/confirm?id=' + this.all_data.saved_id, {}, {
          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        if (data.status === 200) {
          this.$router.push('/rental/calnder');
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
       

    add: function(){
            this.count++;
            this.detail.push({
              qty: 1,
            },)
           
        },

  remove: function () {
            this.count--;
            this.detail.splice({
              
            },1)
            
        },

    },
    
    }
    
    </script>

    <style scoped>
    .button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */
    </style>
    
